import { Link, useLocation } from "wouter";
import { useStoreQuery, queries } from "@/lib/store";
import Icon from "./Icon";

/**
 * Trainerize-style floating message bubble. Anchors above the bottom nav,
 * shows the unread count, and routes to /messages.
 *
 * Hidden on the /messages page itself (we're already there) and on any chat
 * detail page (those pages use hideNav=true so the FAB is already absent
 * via PhoneShell, but we double-check for safety).
 */
export default function FloatingMessageButton() {
  const [location] = useLocation();
  const unread = useStoreQuery(() => queries.totalUnreadMessages());

  // Don't shadow the page on Messages itself
  if (location === "/messages") return null;
  // Belt-and-suspenders: hide on any in-thread route too
  if (location.startsWith("/chat/") || location === "/kiley") return null;

  return (
    <Link href="/messages" data-testid="fab-messages">
      <button
        aria-label={unread > 0 ? `Open messages, ${unread} unread` : "Open messages"}
        className="absolute flex items-center justify-center mnf-fab"
        style={{
          bottom: 92,
          right: 14,
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #C0784A 0%, #A86237 100%)",
          color: "#F5F0E8",
          boxShadow:
            "0 10px 22px rgba(192,120,74,0.42), 0 4px 8px rgba(30,74,53,0.18), inset 0 0 0 2px rgba(245,240,232,0.18)",
          zIndex: 35,
          border: "none",
          cursor: "pointer",
        }}
      >
        <Icon name="forum" size={24} filled />
        {unread > 0 && (
          <span
            className="absolute mnf-body"
            style={{
              top: -4,
              right: -4,
              minWidth: 22,
              height: 22,
              padding: "0 6px",
              borderRadius: 11,
              background: "#1E4A35",
              color: "#F5F0E8",
              fontSize: 11,
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #F5F0E8",
              boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
            }}
            data-testid="badge-fab-unread"
          >
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
    </Link>
  );
}
